<script>
import Vue from 'vue'
import { Popup, Toast } from 'bxs-ui-vue'
import { isToB } from 'base/config'
Vue.use(Toast)
export default {
  name: 'RecordScreen',
  components: {
    [Popup.name]: Popup
  },
  filters: {},
  mixins: [],
  props: {
    value: Boolean
  },
  data() {
    this.isToB = isToB
    return {
      count: 4,
      counting: false
    }
  },
  computed: {
    isSupportRecordScreen() {
      return appBridge && appBridge.checkAppFeature('SHOW_SCREEN_RECORDER')
    }
  },
  watch: {},
  created() {
    this.getRecordScreenStatus()
    // if (appBridge && appBridge.checkAppFeature('ON_APP_BACK_TO_INPUT_PAGE')) {
    //   appBridge.onAppBackToInputPage(function() {
    //     vm.getRecordScreenStatus()
    //   })
    // }
  },
  mounted() {},
  methods: {
    recordScreenInit() {
      this.cdTimer = null
      this.counting = false
      this.count = 4
    },
    // 获取录屏状态
    getRecordScreenStatus() {
      const vm = this
      if (
        !appBridge ||
        !appBridge.checkAppFeature('GET_SCREEN_RECORDER_STATUS')
      )
        return
      appBridge
        .getScreenRecorderStatus()
        .then(res => {
          if (res.isRecording === 1) {
            vm.$emit('to-start')
          } else if (res.isRecording === 0) {
            // 没有在录屏
            vm.$emit('to-end')
          }
        })
        .catch(e => {
          console.log(e.message)
        })
    },
    countdown() {
      const vm = this
      vm.counting = true
      function countIt() {
        vm.count--
        if (vm.count > 0) {
          vm.cdTimer = setTimeout(countIt, 1000)
        } else {
          vm.recordScreenToStart()
        }
      }
      countIt()
    },
    // 开始录屏
    recordScreenToStart() {
      const vm = this
      if (!appBridge || !appBridge.checkAppFeature('SHOW_SCREEN_RECORDER'))
        return
      vm.handleClose()
      setTimeout(() => {
        appBridge
          .showScreenRecorder()
          .then(res => {
            if (res.status === 1) {
              vm.$emit('to-start')
            } else if (res.status === 0) {
              // this.$toast.fail('开启录屏失败')
            }
          })
          .catch(e => {})
      }, 500)
    },
    // 开启计时
    handleCount(direct) {
      if (direct) this.count = 1
      if (this.counting) return
      this.countdown()
    },
    // 关闭录屏弹窗
    handleClose() {
      this.recordScreenInit()
      this.$emit('close')
    }
  }
}
</script>
<template>
  <bxs-popup
    v-if="isSupportRecordScreen"
    v-model="value"
    class="record-screen-wrap"
    :close-on-click-overlay="false"
  >
    <div class="record-screen-hd after-bd-b">
      <h4>录制讲解视频</h4>
      <div class="close" @click="handleClose">
        <i class="iconfont icon-close_line" />
      </div>
    </div>
    <div class="record-screen-bd">
      <p>点击下方按钮，开始录制计划书讲解视频。</p>
      <p>
        您可以一边滚动计划书页面，一边进行讲解。讲解完成后，点击【结束录制】，整个过程将会合成为讲解视频。
      </p>
      <p>
        您可以播放视频预览，保存到系统相册，或者发送给您的客户，就像您当面给客户讲解，展业销售更有效！
      </p>
      <a
        v-if="!isToB"
        href="https://app.winbaoxian.com/view/newsShare/newsAricleShare.html?id=d3dca38809e14e6f9b6a1a285a4e3e95&nw=1"
        class="detail"
      >功能详细说明<i class="iconfont icon-arrows_right" /></a>
      <div class="btn" @click="handleCount">
        <template v-if="counting">
          <span class="number">{{ count }}</span>
        </template>
        <template v-else>
          <i class="iconfont icon-live" /><span class="start">开始录制</span>
        </template>
      </div>
    </div>
  </bxs-popup>
</template>
<style scoped>
@import 'variable';
.record-screen-wrap {
  width: 72%;
  border-radius: 6px;
  background-color: #fff;
}
.record-screen-hd {
  position: relative;
  h4 {
    padding: 15px 0;
    font-size: 17px;
    font-weight: bold;
    color: #333;
    text-align: center;
  }
  .close {
    position: absolute;
    right: 12px;
    top: 12px;
    font-size: 24px;
    &:after {
      @apply --extend-click;
    }
  }
  .icon-close_line {
    font-size: 24px;
    color: #ccc;
  }
}
.record-screen-bd {
  padding: 12px 12px 22px 22px;
  font-size: 14px;
  p {
    position: relative;
    margin-bottom: 9px;
    color: #333;
    line-height: 1.4;
    &:before {
      content: '';
      position: absolute;
      left: -8px;
      top: 8px;
      border: 2px solid #508cee;
      border-radius: 50%;
      vertical-align: middle;
    }
  }
  .detail {
    color: #508cee;
  }
  .btn {
    display: block;
    height: 45px;
    margin-top: 21px;
    border-radius: 6px;
    color: #fff;
    background: #508cee;
    text-align: center;
    line-height: 45px;
    i {
      font-size: 24px;
      vertical-align: middle;
      margin-right: 9px;
      line-height: 1;
    }
    .start {
      font-size: 16px;
    }
    .number {
      font-size: 21px;
    }
    span {
      vertical-align: middle;
    }
  }
}
</style>
